import { render, staticRenderFns } from "./ConfigMenuDisplay.vue?vue&type=template&id=37099042&scoped=true"
import script from "./ConfigMenuDisplay.vue?vue&type=script&lang=js"
export * from "./ConfigMenuDisplay.vue?vue&type=script&lang=js"
import style0 from "./ConfigMenuDisplay.vue?vue&type=style&index=0&id=37099042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37099042",
  null
  
)

export default component.exports